import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import {RealCampusHdr} from './RealCampusHdr'
import { RealCampus } from './RealCampusHome'
import {RealCampusFooter} from './RealCampusFooter'
import { RealCampusFeedback } from './RealCampusFeedback'

const boxStyle: React.CSSProperties = {
    width: '50%',
    backgroundColor: 'white',
    fontFamily: 'BarlowMedium',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '75%',
    height: '30px',
    alignItems: 'center',
    margin:'10px auto'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0,
    fontFamily:'BarlowMedium',
}

const inputStyle: React.CSSProperties = {
    border: '1px solid black',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    flexGrow: 1,
    fontFamily:'BarlowLight'
}

const workStyle: React.CSSProperties = {
    verticalAlign: 'middle',
    width: '44px',
    alignSelf: 'center',
    filter: 'grayscale(90%)'
}

const forgotLinkStyle: React.CSSProperties = {
    display: 'flex',
    fontSize: '13px',
    justifyContent:'center',
    fontFamily:'BarlowMedium',
    color:'blue',
    cursor:'pointer',
    marginTop:'30px',
    marginBottom:'30px'
}
const gcLogo: React.CSSProperties = {
    width:'539px',
    height:'77px'
}
const loginTop: React.CSSProperties = {
    cursor:'pointer',
    margin:'auto'

}
const submitBtn: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#5E6A74',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'BarlowMedium'
}
const arrowStyle: React.CSSProperties = {
    width:'8%',
    display:'inline-block'
}

const bottomDiv: React.CSSProperties = {
    textAlign:'center',
    cursor:'pointer',
    marginTop:'30px',
    marginBottom:'30px'
}
const newGC: React.CSSProperties = {
    marginTop:'15px',
    fontFamily:'BarlowMedium',
    color:'#5E6A74',
    display:'flex',
    justifyContent:'center'
}
const outerDiv: React.CSSProperties = {
    backgroundColor:'#616060',
    height:'600px',
    display:'flex'
}
const loginDiv: React.CSSProperties = {
    fontFamily:'Lulo',
    fontSize:'36px',
    color:'#5E6A74',
    display:'flex',
    justifyContent:'center',
    marginTop:'25px'

}
const createAcct: React.CSSProperties = {
    color:'blue',
    textDecoration:'underline',
    fontFamily:'BarlowMedium'
}
class _RealCampusLogin extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        password: "",
        isWaiting: false
    };

    openRegister = () =>{browserHistory.push(Tgcc.Routes.RealCampusRegister)};
    openHome = () =>{browserHistory.push(Tgcc.Routes.RealCampusHome)};

    componentDidMount(){
        var tag = document.getElementById('campusLogin');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    cancelLogin = () => {
        this.setState({isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null})
    }

    failedLogin = (err: any) => {
        this.setState({isWaiting: false, error: err});
    }

    doLogin = () => {
        if(!this.state.email)
            this.setState({error: 'Email cannot be blank'});
        else if(!this.state.password)
            this.setState({error: 'Password cannot be blank'});
        else {
           this.setState({isWaiting: true});
           Request.loginUser(this.state.email, this.state.password, (ld) => { Tgcc.successfulCampusLogin(this.props.dispatch, ld) }, this.failedLogin)
        }
    }

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    passwordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({password: evt.currentTarget.value});
    }

    keyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doLogin();
    }

    forgotPassword = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.CampusForgotPassword, payload: {email: this.state.email}}});
    }

    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div style={submitBtn} onClick={this.doLogin}>Submit</div>

        var errElement = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div/>
        return(
            <div>
             <RealCampusHdr />
                <div style={outerDiv} className="realCampOuter">
                    <div id="campusLogin"></div>
                    <div style={boxStyle} className="realLoginBox">
                        <div style={loginDiv}>Login</div>
                    <div style={bottomDiv}>
                            <div style={newGC}>NEED A REAL CAMPUS ACCOUNT&#63; <div style={createAcct} onClick={this.openRegister}>CREATE AN ACCOUNT</div></div>
                        </div>
                        {errElement}
                        <div style={rowStyle}>
                            <div style={lblStyle}>Email</div>
                            <input autoFocus type='text' style={inputStyle} name='email' onChange={this.emailChanged} onKeyPress={this.keyPressed}/>
                        </div>
                        <div style={rowStyle}>
                            <div style={lblStyle}>Password</div>
                            <input type='password' style={inputStyle} name='password' onChange={this.passwordChanged} onKeyPress={this.keyPressed}/>
                        </div>
                        <div style={forgotLinkStyle} onClick={this.forgotPassword}><i>forgot password&#63;</i></div>
                        {btnElement}
                    </div>
                    <div style={loginTop} onClick={this.openHome} className="loginTop">
                        <img className="realLogLogo" src={Tgcc.ResolveUrl('~/images/Real_Campus_Logo.png')} style={gcLogo}/>
                    </div>
                </div>
                <RealCampusFeedback state={this.props.state} />
                <RealCampusFooter state={this.props.state} />
                </div>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var RealCampusLogin = connect(mapStateToProps)(Radium(_RealCampusLogin));